import { isProduction, isStaging } from '@/libs/env/index'
import { UTMFields as UTMFieldsModule } from '@frontend/utm_fields'

let instance: UTMFieldsModule = null

const getGA = (): Promise<void> => {
  return new Promise((resolve) => {
    let timeout: number = 0
    if (typeof(ga) === 'undefined' && (isProduction || isStaging)) {
      timeout = window.setInterval(() => {
        if (typeof ga !== 'undefined') {
          window.clearInterval(timeout)
          resolve()
        }
      }, 300)
    } else {
      resolve()
    }
  })
}

export class UTMFields {
  public static clear(): void {
    if (instance) {
      instance.removeUTMFromStorage()
    }
  }

  public static async wait() {
    return await getGA()
  }

  public static async fill() {
    UTMFieldsModule.config({
      UTM_FIELDS: [
        'utm_source',
        'utm_content',
        'utm_term',
        'utm_campaign',
        'utm_medium',
      ],
      driver: 2,
      fieldSelector: (fieldName) => `[data-selector='${ fieldName }']`,
    })

    // tslint:disable-next-line
    instance = new UTMFieldsModule()

    await this.fillGATracker()
  }

  public static async fillGATracker() {
    if (isProduction || isStaging) {
      await getGA()
      ga ((tracker) => {
        const trackerField = document.querySelector('[data-selector="ga_client_id"]') as HTMLInputElement
        trackerField.value = tracker.get('clientId')
      })
    } else {
      return
    }
  }
}
